import {useQuery} from "@tanstack/react-query";

import {companyService} from "../services";

export default function useCompany() {
  const query = useQuery({
    queryKey: ["company"],
    queryFn: () => companyService.getCompany(),
  });

  const company = query.isSuccess ? (query.data ?? null) : null;

  return {...query, company};
}
